import { Component, OnInit } from '@angular/core';
import { GlobalDataService } from '../global-data.service';
import { LoginUser } from '../../_models';

@Component({
  standalone: false,
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  userFromApi!: LoginUser;
  constructor( private gd :GlobalDataService) { }

  ngOnInit() {
    this.userFromApi = this.gd.getUserData();
  }

}
